import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {chestnut} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  lastDayText: {
    color: chestnut,
  },
  container: {
    marginTop: indent * 0.5,
    flexDirection: 'row',
  },
  split: {
    width: 10,
  },
});
